// source: pbtypes/gen/calibration/camera_rig.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_calibration_camera_adjacency_pb = require('../../../pbtypes/gen/calibration/camera_adjacency_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_camera_adjacency_pb);
var pbtypes_gen_calibration_pixel_format_pb = require('../../../pbtypes/gen/calibration/pixel_format_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_pixel_format_pb);
var pbtypes_gen_calibration_single_camera_calibration_pb = require('../../../pbtypes/gen/calibration/single_camera_calibration_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_single_camera_calibration_pb);
var pbtypes_gen_eigen_lcm_Vector2i_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2i_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2i_pb);
var pbtypes_gen_sensors_sensor_model_pb = require('../../../pbtypes/gen/sensors/sensor_model_pb.js');
goog.object.extend(proto, pbtypes_gen_sensors_sensor_model_pb);
goog.exportSymbol('proto.calibration.CameraRig', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.calibration.CameraRig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.calibration.CameraRig.repeatedFields_, null);
};
goog.inherits(proto.calibration.CameraRig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.calibration.CameraRig.displayName = 'proto.calibration.CameraRig';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.calibration.CameraRig.repeatedFields_ = [2,1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.calibration.CameraRig.prototype.toObject = function(opt_includeInstance) {
  return proto.calibration.CameraRig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.calibration.CameraRig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.calibration.CameraRig.toObject = function(includeInstance, msg) {
  var f, obj = {
adjacenciesList: jspb.Message.toObjectList(msg.getAdjacenciesList(),
    pbtypes_gen_calibration_camera_adjacency_pb.CameraAdjacency.toObject, includeInstance),
camerasList: jspb.Message.toObjectList(msg.getCamerasList(),
    pbtypes_gen_calibration_single_camera_calibration_pb.SingleCameraCalibration.toObject, includeInstance),
equidistantEpipolarImageSize: (f = msg.getEquidistantEpipolarImageSize()) && pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.toObject(includeInstance, f),
equidistantEpipolarFov: (f = msg.getEquidistantEpipolarFov()) && pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.toObject(includeInstance, f),
isCalibrated: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
isGimbaled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
sensorModel: (f = msg.getSensorModel()) && pbtypes_gen_sensors_sensor_model_pb.SensorModel.toObject(includeInstance, f),
pixelFormat: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.calibration.CameraRig}
 */
proto.calibration.CameraRig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.calibration.CameraRig;
  return proto.calibration.CameraRig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.calibration.CameraRig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.calibration.CameraRig}
 */
proto.calibration.CameraRig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new pbtypes_gen_calibration_camera_adjacency_pb.CameraAdjacency;
      reader.readMessage(value,pbtypes_gen_calibration_camera_adjacency_pb.CameraAdjacency.deserializeBinaryFromReader);
      msg.addAdjacencies(value);
      break;
    case 1:
      var value = new pbtypes_gen_calibration_single_camera_calibration_pb.SingleCameraCalibration;
      reader.readMessage(value,pbtypes_gen_calibration_single_camera_calibration_pb.SingleCameraCalibration.deserializeBinaryFromReader);
      msg.addCameras(value);
      break;
    case 8:
      var value = new pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.deserializeBinaryFromReader);
      msg.setEquidistantEpipolarImageSize(value);
      break;
    case 9:
      var value = new pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.deserializeBinaryFromReader);
      msg.setEquidistantEpipolarFov(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCalibrated(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGimbaled(value);
      break;
    case 3:
      var value = new pbtypes_gen_sensors_sensor_model_pb.SensorModel;
      reader.readMessage(value,pbtypes_gen_sensors_sensor_model_pb.SensorModel.deserializeBinaryFromReader);
      msg.setSensorModel(value);
      break;
    case 10:
      var value = /** @type {!proto.calibration.PixelFormat.Enum} */ (reader.readEnum());
      msg.setPixelFormat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.calibration.CameraRig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.calibration.CameraRig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.calibration.CameraRig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.calibration.CameraRig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdjacenciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      pbtypes_gen_calibration_camera_adjacency_pb.CameraAdjacency.serializeBinaryToWriter
    );
  }
  f = message.getCamerasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      pbtypes_gen_calibration_single_camera_calibration_pb.SingleCameraCalibration.serializeBinaryToWriter
    );
  }
  f = message.getEquidistantEpipolarImageSize();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.serializeBinaryToWriter
    );
  }
  f = message.getEquidistantEpipolarFov();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb.serializeBinaryToWriter
    );
  }
  f = message.getIsCalibrated();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsGimbaled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSensorModel();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_sensors_sensor_model_pb.SensorModel.serializeBinaryToWriter
    );
  }
  f = message.getPixelFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * repeated CameraAdjacency adjacencies = 2;
 * @return {!Array<!proto.calibration.CameraAdjacency>}
 */
proto.calibration.CameraRig.prototype.getAdjacenciesList = function() {
  return /** @type{!Array<!proto.calibration.CameraAdjacency>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_calibration_camera_adjacency_pb.CameraAdjacency, 2));
};


/**
 * @param {!Array<!proto.calibration.CameraAdjacency>} value
 * @return {!proto.calibration.CameraRig} returns this
*/
proto.calibration.CameraRig.prototype.setAdjacenciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.calibration.CameraAdjacency=} opt_value
 * @param {number=} opt_index
 * @return {!proto.calibration.CameraAdjacency}
 */
proto.calibration.CameraRig.prototype.addAdjacencies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.calibration.CameraAdjacency, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.calibration.CameraRig} returns this
 */
proto.calibration.CameraRig.prototype.clearAdjacenciesList = function() {
  return this.setAdjacenciesList([]);
};


/**
 * repeated SingleCameraCalibration cameras = 1;
 * @return {!Array<!proto.calibration.SingleCameraCalibration>}
 */
proto.calibration.CameraRig.prototype.getCamerasList = function() {
  return /** @type{!Array<!proto.calibration.SingleCameraCalibration>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_calibration_single_camera_calibration_pb.SingleCameraCalibration, 1));
};


/**
 * @param {!Array<!proto.calibration.SingleCameraCalibration>} value
 * @return {!proto.calibration.CameraRig} returns this
*/
proto.calibration.CameraRig.prototype.setCamerasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.calibration.SingleCameraCalibration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.calibration.SingleCameraCalibration}
 */
proto.calibration.CameraRig.prototype.addCameras = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.calibration.SingleCameraCalibration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.calibration.CameraRig} returns this
 */
proto.calibration.CameraRig.prototype.clearCamerasList = function() {
  return this.setCamerasList([]);
};


/**
 * optional eigen_lcm.Vector2iPb equidistant_epipolar_image_size = 8;
 * @return {?proto.eigen_lcm.Vector2iPb}
 */
proto.calibration.CameraRig.prototype.getEquidistantEpipolarImageSize = function() {
  return /** @type{?proto.eigen_lcm.Vector2iPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb, 8));
};


/**
 * @param {?proto.eigen_lcm.Vector2iPb|undefined} value
 * @return {!proto.calibration.CameraRig} returns this
*/
proto.calibration.CameraRig.prototype.setEquidistantEpipolarImageSize = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.calibration.CameraRig} returns this
 */
proto.calibration.CameraRig.prototype.clearEquidistantEpipolarImageSize = function() {
  return this.setEquidistantEpipolarImageSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.calibration.CameraRig.prototype.hasEquidistantEpipolarImageSize = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional eigen_lcm.Vector2iPb equidistant_epipolar_fov = 9;
 * @return {?proto.eigen_lcm.Vector2iPb}
 */
proto.calibration.CameraRig.prototype.getEquidistantEpipolarFov = function() {
  return /** @type{?proto.eigen_lcm.Vector2iPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2i_pb.Vector2iPb, 9));
};


/**
 * @param {?proto.eigen_lcm.Vector2iPb|undefined} value
 * @return {!proto.calibration.CameraRig} returns this
*/
proto.calibration.CameraRig.prototype.setEquidistantEpipolarFov = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.calibration.CameraRig} returns this
 */
proto.calibration.CameraRig.prototype.clearEquidistantEpipolarFov = function() {
  return this.setEquidistantEpipolarFov(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.calibration.CameraRig.prototype.hasEquidistantEpipolarFov = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool is_calibrated = 6;
 * @return {boolean}
 */
proto.calibration.CameraRig.prototype.getIsCalibrated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.calibration.CameraRig} returns this
 */
proto.calibration.CameraRig.prototype.setIsCalibrated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_gimbaled = 4;
 * @return {boolean}
 */
proto.calibration.CameraRig.prototype.getIsGimbaled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.calibration.CameraRig} returns this
 */
proto.calibration.CameraRig.prototype.setIsGimbaled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional sensors.SensorModel sensor_model = 3;
 * @return {?proto.sensors.SensorModel}
 */
proto.calibration.CameraRig.prototype.getSensorModel = function() {
  return /** @type{?proto.sensors.SensorModel} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_sensors_sensor_model_pb.SensorModel, 3));
};


/**
 * @param {?proto.sensors.SensorModel|undefined} value
 * @return {!proto.calibration.CameraRig} returns this
*/
proto.calibration.CameraRig.prototype.setSensorModel = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.calibration.CameraRig} returns this
 */
proto.calibration.CameraRig.prototype.clearSensorModel = function() {
  return this.setSensorModel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.calibration.CameraRig.prototype.hasSensorModel = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PixelFormat.Enum pixel_format = 10;
 * @return {!proto.calibration.PixelFormat.Enum}
 */
proto.calibration.CameraRig.prototype.getPixelFormat = function() {
  return /** @type {!proto.calibration.PixelFormat.Enum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.calibration.PixelFormat.Enum} value
 * @return {!proto.calibration.CameraRig} returns this
 */
proto.calibration.CameraRig.prototype.setPixelFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


goog.object.extend(exports, proto.calibration);
